// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { FormControl, InputBase, NativeSelect, Paper, withStyles } from '@material-ui/core';

// Internal Dependencies
import MText from '../../../../components/Common/MText';
import { titleTextSize } from '../LoyaltyCardStyle';
import Colours from '../../../../styles/colours';
import PeriodStatsPanel from './PeriodStatsPanel';
import Overview from './Overview';
import Constants from '../../../../common/constants';

const buttonColor = Colours.LightBlue;

const BootstrapInput = withStyles(() => ({
  input: {
    borderRadius:    2,
    position:        'relative',
    backgroundColor: buttonColor,
    fontSize:        '.8rem',
    color:           Colours.White,
    padding:         '10px 26px 12px 12px',
    width:           150,
    textAlign:       'center',
    '&:focus':       {
      borderRadius:    2,
      backgroundColor: buttonColor,
    },
  },
}))(InputBase);

const Analytics = ({ match }) => {
  const { loyaltyCardId, pageId } = match.params;
  const [selectedPeriod, setSelectedPeriod] = useState(Constants.PeriodType.PastWeek);

  return (
    <Paper className="pt-3 pb-5 mb-4 pl-sm-3 position-relative">
      <div className="container-fluid pr-4">
        <div className="row mb-3">
          <div className="col-12 col-lg-5">
            <MText bold text="ANALYTICS" size={titleTextSize} />
          </div>
        </div>

        <Overview
          loyaltyCardId={loyaltyCardId}
          pageId={pageId}
        />
        <div className="d-flex flex-row justify-content-end mt-2">
          <ul>
            <li>
              <MText text="PDA: per day average" />
            </li>
            <li>
              <MText text="New sign-ups: accounts with 1st receipt submission" />
            </li>
          </ul>
        </div>

        <div className="ml-4">
          <div className="d-flex flex-row align-items-center">
            <MText size=".9rem" text="Select period:" />
            <FormControl className="ml-2">
              <NativeSelect
                value={selectedPeriod}
                onChange={(e) => setSelectedPeriod(e.target.value)}
                input={<BootstrapInput />}
              >
                {
                  [Constants.PeriodType.PastWeek, Constants.PeriodType.PastMonth, Constants.PeriodType.YTD].map((period) => (
                    <option
                      key={period}
                      className="text-dark"
                      value={period}
                    >
                      {period}
                    </option>
                  ))
                }
              </NativeSelect>
            </FormControl>
          </div>
          <div className="mt-4">
            <PeriodStatsPanel
              period={selectedPeriod}
              pageId={pageId}
              loyaltyCardId={loyaltyCardId}
            />
          </div>
        </div>

      </div>
    </Paper>
  );
};

Analytics.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default Analytics;
